var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 10 10",
      },
    },
    [
      _c("g", { attrs: { "data-name": "Group 301" } }, [
        _c("path", {
          staticStyle: { fill: "none" },
          attrs: { "data-name": "Rectangle 42", d: "M0 0h10v10H0z" },
        }),
        _c("path", {
          style: `fill: ${_vm.colorSet}`,
          attrs: {
            d: "m11.935 5.161-1.15-.575a.317.317 0 0 1-.175-.286v-.405c.028-.034.057-.072.087-.114a2.754 2.754 0 0 0 .355-.7.477.477 0 0 0 .28-.435v-.48a.48.48 0 0 0-.12-.316v-.64a1.079 1.079 0 0 0-.252-.785A1.515 1.515 0 0 0 9.768 0a1.515 1.515 0 0 0-1.193.425 1.079 1.079 0 0 0-.252.785v.64a.48.48 0 0 0-.12.316v.481a.478.478 0 0 0 .18.374 2.525 2.525 0 0 0 .422.871v.4a.318.318 0 0 1-.166.279l-1.073.586A1.085 1.085 0 0 0 7 6.108V6.5c0 .571 1.81.722 2.768.722s2.768-.151 2.768-.722v-.368a1.08 1.08 0 0 0-.601-.971z",
            transform: "translate(-4.767 1.39)",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }